import { Spacing } from 'UI'

export default theme => ({
  header: {
    backgroundColor: theme.neutral[400],
    alignItems: 'center',
    overflow: 'hidden',
    padding: () => Spacing(5),
    margin: Spacing(0, 0, 4, 0),
    display: 'flex',
    justifyContent: 'space-between'
  },
  projectPictures: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    overflow: 'hidden',
    position: 'absolute',
    right: 24,
    top: 42
  },
  image: {
    borderRadius: 4,
    cursor: 'pointer',
    filter: 'brightness(0.5)',
    width: '100%',
    height: 'auto',
    maxWidth: 120,
    maxHeight: 69
  },
  selectedImageStyle: {
    border: `2px solid ${theme.neutral[400]}`,
    filter: 'brightness(1)'
  },
  gallery: {
    position: 'relative'
  },
  projectText: {
    padding: () => Spacing(5),
    margin: () => Spacing(5),
    borderRadius: 8,
    backgroundColor: 'rgba(0,0,0,0.31)',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center'
  },
  arrowsContainer: {
    display: 'flex',
    position: 'absolute',
    gap: 10,
    margin: 24
  },
  buttonStyle: {
    color: theme.neutral[400],
    cursor: 'pointer',
    borderRadius: '50% !important',
    backgroundColor: 'rgba(0,0,0,0.21) !important',
    height: '55px !important',
    width: '55px !important'
  },
  leftIcon: {
    transform: 'rotate(180deg)'
  },
  bigImage: {
    objectFit: 'contain',
    backgroundColor: 'rgba(0,0,0,0.5)',
    width: '100%',
    height: 'auto',
    maxHeight: 'calc(100vh - 300px)'
  }
})
